// extracted by mini-css-extract-plugin
export default {"inspect-map__container":"InspectList_inspect-map__container__NLhKT","item":"InspectList_item__ZmoUX"};